// src/auth/AdminRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const AdminRoute = ({ children }) => {
	const { role, loading } = useAuth();
	const location = useLocation();

	// ⏳ Wait for auth to resolve
	if (loading) {
		return (
			<div className="flex h-[60vh] items-center justify-center text-slate-600">
				Checking permissions...
			</div>
		);
	}

	// 🚫 Not admin → redirect (never render admin UI)
	if (role !== "fl-admin") {
		return (
			<Navigate
				to="/dashboard"
				replace
				state={{ from: location.pathname }}
			/>
		);
	}

	// ✅ Admin → render page
	return <>{children}</>;
};

export default AdminRoute;
